import { Document as ApiDocument } from "entities/ApiModel/Document";
import { Document as UiDocument } from "entities/UIModel/Document";
import { UWADocument as ApiUWADocument } from "entities/ApiModel/UWADocument";
import { UWADocument as UiUWADocument } from "entities/UIModel/UWADocument";
import { removeWhiteSpaces } from "utils/shared";

export const mapToUiDocument = (d: ApiDocument)  => {
  const uiDocument: UiDocument = {
    uniqueIdentifier: (d.DocumentID || 0).toString(),
    rowId: d.IdentityKey || 0,
    documentID: d.DocumentID,
    // id: d.DocumentID,  // was initialy used
    integrationKey: d.IntegrationKey,
    fileID: d.FileID,
    orderID: d.OrderID,
    messageID: d.MessageID,
    documentTypeCode: d.DocumentTypeCode,
    documentFileTypeCode: d.DocumentFileTypeCode,
    documentFileTypeName: d.DocumentFileTypeName,
    documentPath: d.DocumentPath,
    documentFileName: d.DocumentFileName,
    documentVersion: d.DocumentVersion,
    documentSize: d.DocumentSize,
    documentOriginalFileName: d.DocumentOriginalFileName,
    documentDisplayFileName: d.DocumentDisplayFileName,
    documentDescription: d.DocumentDescription,
    documentStatusTypeCode: d.DocumentStatusTypeCode,
    documentStatusTypeName: d.DocumentStatusTypeName,
    externalReferenceID: d.ExternalReferenceID,
    documentCreatedByUserID: d.DocumentCreatedByUserID,
    documentCreatedByUserName: d.DocumentCreatedByUserName,
    documentCreatedDateOriginal: d.DocumentCreatedDate,
    documentCreatedDate: d.DocumentCreatedDate,
    documentSourceTypeCode: d.DocumentSourceTypeCode,
    documentSourceTypeName: d.DocumentSourceTypeName,
    originationSource: d.OriginationSource,
    originationUser: d.OriginationUser,
    isHidden: d.IsHidden,
    rowClassName: d.OriginationSource &&
    ["resware", "stewarttitleproduction"].includes(removeWhiteSpaces(d.OriginationSource).toLowerCase())
      ? "resware"
      : ""  
  };

  return uiDocument;
}

export const mapToUiUWADocument = (d: ApiUWADocument)  => {
  const uiDocument: UiUWADocument = {
    uniqueIdentifier: (d.UWADocumentID || 0).toString(),
    rowId: d.IdentityKey || 0,
    uwaDocumentID: d.UWADocumentID,
    uwaRequestID: d.UWARequestID,
    integrationKey: d.IntegrationKey,
    fileID: d.FileID,
    orderID: d.OrderID,
    messageID: d.MessageID,


    // displayFileName: d.DisplayFileName,
    displayFileName: d.DisplayFileName + (d.FileExt ? `.${d.FileExt}` : `` ),
    documentStatusTypeCode: d.DocumentStatusTypeCode,
    filePath: d.FilePath,
    fileName: d.FileName,
    fileSize: d.FileSize,
    fileExt: d.FileExt,
    origCreatedBy: d.OrigCreatedBy,
    origCreatedByName: d.OrigCreatedByName,
    origCreatedByDisplayName: d.OrigCreatedByDisplayName,
    documentCreatedDate: d.DocumentCreatedDate,
    originationSource: d.OriginationSource,
    isHidden: d.IsHidden,
    documentDisplayFileName :d.DocumentDisplayFileName,

    // uwaDocumentTypeCode: d.UwaDocumentTypeCode,
    // uwaDocumentTypeName: d.UwaDocumentTypeName,
    // filePath: d.FilePath,
    // fileName: d.FileName,
    // documentVersion: d.DocumentVersion,
    // documentOriginalFileName: d.DocumentOriginalFileName,
    // documentDescription: d.DocumentDescription,
    // externalReferenceID: d.ExternalReferenceID,
    // documentSourceTypeCode: d.DocumentSourceTypeCode,
    // originationUser: d.OriginationUser,
    // rowClassName: "",
  };

  return uiDocument;
}

export const mapToUiDocuments = (data: ApiDocument[]) => (): UiDocument[] => {
  if (!data || data?.length === 0) {
    return [];
  }

  return data.map((d: ApiDocument) => {
    return mapToUiDocument(d);
  });
};

export const mapToUiUWADocuments = (data: ApiUWADocument[]) => (): UiUWADocument[] => {
  if (!data || data?.length === 0) {
    return [];
  }

  return data.map((d: ApiUWADocument) => {
    return mapToUiUWADocument(d);
  });
};


export const mapToApiDocument = (d: UiDocument) => {
  const apiDocument: ApiDocument = {
    DocumentID: d.documentID || 0,
    IntegrationKey: d.integrationKey,
    FileID: d.fileID || 0,
    OrderID: d.orderID || 0,
    MessageID: d.messageID || 0,
    DocumentTypeCode: d.documentTypeCode,
    DocumentFileTypeCode: d.documentFileTypeCode,
    DocumentFileTypeName: d.documentFileTypeName,
    DocumentPath: d.documentPath,
    DocumentFileName: d.documentFileName,
    DocumentVersion: d.documentVersion,
    DocumentSize: d.documentSize,
    DocumentOriginalFileName: d.documentOriginalFileName,
    DocumentDisplayFileName: d.documentDisplayFileName,
    DocumentDescription: d.documentDescription,
    DocumentStatusTypeCode: d.documentStatusTypeCode,
    DocumentStatusTypeName: d.documentStatusTypeName,
    ExternalReferenceID: d.externalReferenceID,
    DocumentCreatedByUserID: d.documentCreatedByUserID,
    DocumentCreatedByUserName: d.documentCreatedByUserName,
    DocumentCreatedDate: d.documentCreatedDateOriginal,
    DocumentSourceTypeCode: d.documentSourceTypeCode,
    DocumentSourceTypeName: d.documentSourceTypeName,
    OriginationSource: d.originationSource,
    OriginationUser: d.originationUser,
    IsHidden: d.isHidden || 0,
  };

  return apiDocument;
};

export const mapToApiDocuments = (data: UiDocument[]) => (): ApiDocument[] => {
  if (!data || data?.length === 0) {
    return [];
  }

  return data.map((d: UiDocument) => {
    return mapToApiDocument(d);
  });
}


